import Swiper from "swiper";
import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const.js";

class DepartmentsSlider {
    constructor(el) {
        this.el = el;
        this.itemsLenght = this.el.querySelectorAll(".js-department-slider-item").length;
        this.mySwiper;
        this.init();
    }

    init() {
        if (this.itemsLenght > 3) {
            this.enable();
        } else if (this.itemsLenght > 1) {
            let breakpoint = window.matchMedia(`(min-width:${LG_WIDTH}px)`);
            if (this.itemsLenght === 2) {
                breakpoint = window.matchMedia(`(min-width:${MD_WIDTH}px)`);
            }
            this.breakpointChecker(breakpoint);
            breakpoint.addEventListener("change", () => this.breakpointChecker(breakpoint));
        }
    }

    enable() {
        this.el.classList.remove("department__contacts-swiper--no-swiper");
        this.mySwiper = new Swiper(this.el, {
            slidesPerView: "auto",
            spaceBetween: 32,
        });
    }

    breakpointChecker(breakpoint) {
        if (breakpoint.matches) {
            if (this.mySwiper !== undefined) {
                this.mySwiper.destroy(true, true);
                this.el.classList.add("department__contacts-swiper--no-swiper");
            }
        } else {
            this.enable();
        }
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-department-slider")
        .forEach(slider => new DepartmentsSlider(slider));
});
